import {addVariantToCart} from './shopify';

$(function() {
  let productStandard = $('.product-standard');

  productStandard.on('click', '[data-add]', function(e){
    e.preventDefault();

    let thisSubmit = $(this);

    thisSubmit.siblings('.error').remove();

    addVariantToCart(thisSubmit.data('add'), $('#quantity').val());
  })
})